<script setup>
import AboutContent from '../Documents/About.vue'
import NextButton from '../NextButton.vue'
import PreviousButton from '../PreviousButton.vue'

defineEmits(['open-window', 'minimize-window'])
</script>

<template>
  <div class="relative right-0 h-content-window overflow-hidden">
    <div class="w-full h-full bg-white overflow-auto p-2 pb-28">
      <AboutContent />
      <PreviousButton current-window-id="about" @open-window="$emit('open-window', $event)" @minimize-window="$emit('minimize-window', $event)" />
      <NextButton current-window-id="about" @open-window="$emit('open-window', $event)" @minimize-window="$emit('minimize-window', $event)" />
    </div>
  </div>
</template>
